<template>
  <div>
    <!-- <router-link to="/Ztzl?id=26&index=1">jfjgsk</router-link> -->
    <div class="content gWidth bg-white" id="conts" v-cloak >
      <section class="cont_t margin-bottom-lg" style="padding: 20px; text-align: center;">
      <!-- 标题、描述、更多 合并为一行 -->
      <div class="cont_t_line flex align-center flex-center">
        <a
          v-if="tj.link"
          :href="tj.link"
          target="_blank"
          class="cont_t_t_s truncate-text"
          >{{ tj.title }}</a
        >
        <router-link
          v-else
          :to="`/Dxarticles/${tj.id}`"
          class="cont_t_t_s truncate-text"
          >{{ tj.title }}</router-link
        >
        <span class="text-over cont_t_des_text">{{ tj.description }}</span>
        <a v-if="tj.link" :href="tj.link" target="_blank" class="cont_t_more">
          更多 >>
        </a>
        <router-link v-else :to="`/Dxarticles/${tj.id}`" class="cont_t_more">
          更多 >>
        </router-link>
      </div>
   
        <div class="deliver"></div>
        <div class="cont_t_in">
          <div class="left">
            <!-- 信息欧美系 -->
            <swiper ref="mySwiper" :options="swiperOptions" style="height:100%">
              <swiper-slide v-for="item in tjpics" :key="item.id">
                <div class="swiper-slide">
                  <router-link :to="item.link" v-if="item.state == 1">
                    <img :src="'http://' + item.thumb" :alt="item.title" />
                    <p
                      class="
                        banner_tit
                        text-white text-weight text-sm
                        padding-left
                        flex
                        align-center
                      "
                      style="position: absolute"
                    >
                      <span class="text-over flex align-center">{{
                        item.title
                      }}</span>
                    </p>
                  </router-link>
                  <a :href="item.link" target="_blank" class="relative" v-else>
                    <img :src="'http://' + item.thumb" :alt="item.title" />
                    <p
                      class="
                        banner_tit
                        text-white text-weight text-sm
                        padding-left
                        flex
                        align-center
                      "
                      style="position: absolute"
                    >
                      <span class="text-over flex align-center">{{
                        item.title
                      }}</span>
                    </p>
                  </a>
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
            <!-- 信息欧美系ebd -->
          </div>
          <div class="right">
            <div class="rit_t margin-bottom flex">
              <span
                class="text-weight bg-gray cursor"
                :class="{ 'bg-blue': isGuowu }"
                @click="isGw(true)"
                >国务要闻</span
              >
              <span
                class="text-weight bg-gray cursor"
                :class="{ 'bg-blue': !isGuowu }"
                @click="isGw(false)"
                >高区动态</span
              >
            </div>
            <ul class="rit_b text-gray" v-if="isGuowu" style="text-align: left;">
              <li
                class="flex flex-between"
                v-for="item in yaowens"
                :key="item.id"
              >
                <a
                  :href="item.link"
                  target="_blank"
                  class="text-gray hover_a text-over"
                  >{{ item.description }}</a
                >
                <span style="text-align: right">{{ item.pubDate }}</span>
              </li>
            </ul>
            <ul class="rit_b text-gray" v-else  style="text-align: left;">
              <li
                class="flex flex-between"
                v-for="item in gqdongtais"
                :key="item.id"
              >
                <router-link
                  :to="`/Dxarticles/${item.id}`"
                  class="hover_a text-gray text-over"
                >
                  {{ item.title }}
                </router-link>

                <span style="text-align: right">{{ item.created_at }}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <!-- section 2 -->
      <section class="margin-bottom-lg">
        <div class="banner_row" style="overflow: hidden;position: relative;">
          <swiper
            ref="mySwiper2"
            :options="swiperOptions2"
            style="height:100%"
            v-if="swiperVisible"
          >
            <swiper-slide v-for="item in gglunbos" :key="item.id">
              <div class="swiper-slide">
                <router-link :to="item.url" v-if="item.state == 1">
                  <img :src="'http://' + item.img" :alt="item.name" />
                </router-link>
                <a :href="item.url" target="_blank" v-else>
                  <img :src="'http://' + item.img" :alt="item.name" />
                </a>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
          <!-- fkdsjf; end -->
        </div>
      </section>
      <!-- section 3 -->
      <section class="news margin-bottom-sm">
        <div class="news_l com_l_width">
          <div class="top bg-gray com_height flex flex-between align-center">
            <div class="text-lg flex align-center" style="width: 75%">
              <span
                class="text-center text-weight cursor"
                :class="{ 'bg-blue': isTongzhi }"
                @click="isTg(true)"
                >通知公告</span
              >
              <span
                class="bg-gray text-center text-weight cursor"
                :class="{ 'bg-blue': !isTongzhi }"
                @click="isTg(false)"
                >审批公示</span
              >
            </div>
            <router-link
              to="GonggaoList"
              class="text-blue text-lg margin-right text-weight"
              v-if="isTongzhi"
              >MORE</router-link
            >
            <a
              href="http://bdgx.hbzwfw.gov.cn/col/col681/index.html"
              target="_blank"
              class="text-blue text-lg margin-right text-weight"
              v-else
              >MORE</a
            >
          </div>
          <ul
            class="btm com_in_height padding-top-sm padding-right padding-left"
            v-if="isTongzhi"
          >
            <li
              class="flex flex-between text-sm"
              v-for="(item, indextz) in gggss"
              :key="indextz"
            >
            <div v-if="item.link.includes('bdgxq')"  class="flex flex-between text-sm" style="width: 98%">
                <router-link
                  :to="`/Dxarticles/${item.id}`"
                  class="text-sm text-over text-gray hover_a"
                >
                  {{ item.title }}
                </router-link>
                <span>
                  {{ item.created_at }}
                </span>
              </div>
              <div v-else  class="flex flex-between text-sm" style="width: 98%">
                <a
                  :href="item.link"
                  class="text-sm text-over text-gray hover_a aaa"
                >
                  {{ item.title }}
                </a>
              
                <span style="text-align: right">
                  {{ item.created_at }}
                </span>
              </div>
            </li>
          </ul>
          <!-- <div
            class="btm com_in_height padding-top-sm"
            style="width: 100%"
            v-else
          > -->
            <!-- <iframe
              src="static/gongshi.html"
              width="100%"
              height="180"
              frameborder="0"
              scrolling="no"
            ></iframe> -->
            <!-- <iframe
              src="https://www.bdgxq.gov.cn/gongshi.php"
              width="100%"
              height="180"
              frameborder="0"
              scrolling="no"
              class="iframesss"
              ref="myRef"
              id="iframesss"
              @load="hideImg()"
            ></iframe> -->
          <!-- </div> -->
          <ul
            class="btm com_in_height padding-top-sm padding-right padding-left"
            v-else
          >
            <li
              class="flex flex-between text-sm"
              v-for="(item, indextz) in spgs"
              :key="indextz"
            >
              <a :href="item.link" target="_blank" class="text-sm text-over text-gray hover_a"> {{ item.title }}</a>
              <span>
                {{ item.created_at }}
              </span>
            </li>
          </ul>
        </div>
        <div class="news_r com_r_width com_r_width_mt">
          <div
            class="
              top
              flex flex-between
              bg-gray
              com_height
              align-center
              padding-lr
            "
          >
            <span class="text-weight text-lg text-blue">{{
              remengfws.name
            }}</span>
            <a
              href="http://bdgx.hbzwfw.gov.cn/"
              target="_blank"
              class="text-weight text-lg text-blue"
              >MORE</a
            >
          </div>
          <ol
            class="btm com_in_height flex flex-wrap com_r_width"
            style="width: 100%"
          >
            <li v-for="(item, indexrm) in remengfws.data" :key="indexrm">
              <a :href="item.url" target="_blank" class="flex flex-column">
                <img :src="'http://' + item.ico" alt="" />
                <p class="text-sm">{{ item.name }}</p>
              </a>
            </li>
          </ol>
        </div>
      </section>
       <!-- 中间的广告图 -->
<!--       <section class="things margin-bottom-sm">-->
<!--        <div> <a href="https://www.bdgxq.gov.cn/#/ztzl?id=153&index=12" target="_blank" ><img src="https://0312-1256237687.cos.ap-beijing.myqcloud.com/files/huodong.jpg" width="100%"></a> </div>-->
<!--        </section>-->
     <div class="top com_height flex align-center" style="border: 1px solid #007aff; margin-bottom: 20px; display: flex; align-items: center; justify-content:space-around; ">
            <span class="text-sm text-weight">办事统计数据:</span>
            <span class="text-sm text-weight">部门：{{shujuzz.deptcount}}</span>
            <span class="text-sm text-weight">主项：{{shujuzz.fatheritem}}</span>
            <span class="text-sm text-weight">子项：{{shujuzz.sonitem}}</span>
            <span class="text-sm text-weight">办件数量：{{shujuzz.banjian}}</span>
          </div>
      <!-- section4 -->
      <section class="things margin-bottom-lg">
        <div class="things_l com_l_width">
          <div
            class="
              top
              bg-gray
              com_height
              flex flex-between
              align-center
              margin-bottom-sm
            "
          >
            <div class="text-lg flex align-center" style="width: 75%">
              <span
                class="text-center text-weight cursor"
                :class="{ 'bg-blue': isPersonal }"
                @click="isPer(true)"
                >{{ gerenbss.name }}</span
              >
              <span
                class="bg-gray text-center text-weight cursor"
                :class="{ 'bg-blue': !isPersonal }"
                @click="isPer(false)"
                >{{ farenbss.name }}</span
              >
            </div>
            <a
              href="http://www.hbzwfw.gov.cn/hbzw/threesxcx/itemList/gr_index.do?webId=118&zt=07&deptid="
              target="_blank"
              class="text-blue text-lg margin-right text-weight"
              v-if="isPersonal"
              >MORE</a
            >
            <a
              href="http://www.hbzwfw.gov.cn/hbzw/threesxcx/itemList/fr_index.do?webId=118&enterprise_zt=01&deptid="
              target="_blank"
              class="text-blue text-lg margin-right text-weight"
              v-else
              >MORE</a
            >
          </div>
          <!-- <ul class="btm  flex flex-wrap" v-if="isPersonal" style="height: 249px;"> -->

          <ul class="btm flex flex-wrap" v-if="isPersonal">
            <li
              class="flex flex-between text-sm"
              v-for="(item, indexgr) in gerenbss.data"
              :key="indexgr"
            >
              <a :href="item.url" target="_blank" class="relative">
                <img :src="'http://' + item.ico" :alt="item.name" />
                <p
                  style="position: absolute; bottom: 6px; width: 100%"
                  class="text-center text-gray"
                >
                  {{ item.name }}
                </p>
              </a>
            </li>
          </ul>
          <!-- <div class="bd faren" style="height: 249px;" v-else> -->
          <div class="bd faren" v-else>
            <ul class="flex flex-wrap">
              <li v-for="(item, indexfr) in farenbss.data" :key="indexfr">
                <a
                  :href="item.url"
                  target="_blank"
                  class="flex flex-center align-center text-sm"
                  >{{ item.name }}</a
                >
              </li>
            </ul>
          </div>



        </div>
        <div class="things_r com_r_width">
          <div
            class="
              top
              flex flex-between
              bg-gray
              com_height
              align-center
              padding-lr
            "
          >
            <span class="text-weight text-lg text-blue">{{
              kuaijiefws.name
            }}</span>
            <!-- <a href="#" class="text-weight text-lg text-blue">MORE</a> -->
          </div>
          <div class="thing_in">
            <ol class="btm com_in_height">
              <li class="flex align-center">
                <div class="img flex align-center flex-center">
                  <img src="../../assets/wyk.png" alt="" />
                  <span class="text-white text_mid">我要看</span>
                </div>
                <a
                  :href="item.url"
                  class="text-sm text-gray hover_a"
                  target="_blank"
                  style="margin-right: 24px"
                  v-for="(item, indexlook) in kjfw_look"
                  :key="indexlook"
                  >{{ item.name }}</a
                >
              </li>
              <li class="flex align-center">
                <div class="img flex align-center flex-center">
                  <img src="../../assets/wyc.png" alt="" />
                  <span class="text-white text_mid">我要查</span>
                </div>
                <a
                  :href="item.url"
                  class="text-sm text-gray hover_a"
                  target="_blank"
                  style="margin-right: 24px"
                  v-for="(item, indexsearch) in kjfw_search"
                  :key="indexsearch"
                  >{{ item.name }}</a
                >
              </li>
              <li class="flex align-center">
                <div class="img flex align-center flex-center">
                  <img src="../../assets/wyw.png" alt="" />
                  <span class="text-white text_mid">我要问</span>
                </div>
                <a
                  :href="item.url"
                  class="text-sm text-gray hover_a"
                  target="_blank"
                  style="margin-right: 24px"
                  v-for="(item, indexask) in kjfw_ask"
                  :key="indexask"
                  >{{ item.name }}</a
                >
              </li>
            </ol>
          </div>
        </div>
      </section>

      <!-- section5 -->
      <section class="padding-bottom">
        <div class="links">
          <div class="top com_height bg-blue flex align-center">
            <img src="../../assets/link.png.jpg" alt="" />
            <span class="text-lg text-weight text-white">友情链接</span>
          </div>
          <div class="btm">
            <div class="link_tit flex flex-center align-center margin-bottom">
              <!-- <a href="#" class="text-weight befor_parent" :class="{'text-blue':mouseSelsct==indexlink}" @mouseenter="mouseOver(indexlink)" v-for="(item,indexlink) in youlinks" :key="indexlink">
									<span class="title_fonts">{{item.title}}</span>
									<span class="befores bg-blue" v-if="mouseSelsct==indexlink"></span>
								</a> -->
              <div
                class="text-weight befor_parent"
                :class="{ 'text-blue': mouseSelsct == indexlink }"
                @mouseenter="mouseOver(indexlink)"
                v-for="(item, indexlink) in youlinks"
                :key="indexlink"
              >
                <span class="title_fonts">{{ item.title }}</span>
                <span
                  class="befores bg-blue"
                  v-if="mouseSelsct == indexlink"
                ></span>
              </div>
            </div>
            <div v-for="(item, indexlkb) in youlinks" :key="indexlkb">
              <div class="link_cont" v-if="mouseSelsct == indexlkb">
                <dl>
                  <dd class="flex flex-wrap">
                    <a
                      :href="item2.url"
                      target="_blank"
                      v-for="(item2, index2) in item.sub"
                      :key="index2"
                    >
                      <span class="text-blue">
                        <img src="../../assets/jiantou.png" />
                      </span>
                      <span class="text-sm lightgray hover_a">{{
                        item2.name
                      }}</span>
                    </a>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- <div class="floats"> 
         <a target="_blank" href="https://haoyuan-1300669354.cos.ap-beijing.myqcloud.com/01/0407%E4%BF%9D%E5%AF%86%E5%AE%A3%E4%BC%A0%E5%85%AC%E7%9B%8A%EF%BC%88%E7%BD%91%E7%BB%9C%E5%AA%92%E4%BD%93%E7%89%88%EF%BC%89%20%281%29.mp4">
           <img src="../../assets/floats.png" alt="" />
         </a>
      </div> -->
      <!-- //调整右侧right距离 -->
      <div style="position: fixed; top: 360px; right: 15px; width: 120px;">
        <a href="https://www.bdgxq.gov.cn/#/tousujubao">
          <img src="https://www.bdgxq.gov.cn/img/123500.png" alt="" width="120">
        </a>
        
        <a  href="https://tousu.www.gov.cn/dc/2023zhdc/index.htm">
          <img  src="https://www.bdgxq.gov.cn/storage/ducha20231023.jpg" alt="" width="120">
        </a>
        
        <a href="https://www.bdgxq.gov.cn/images/20240201182903.png" style="margin-top: 5px;">
          <img  src="https://gxq-oa-1308127368.cos.ap-beijing.myqcloud.com/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20230818104546.jpg" alt="" width="120">
        </a>
        
        <a  href="https://tousu.www.gov.cn/dc/2024yxyshjjs/index.htm" style="margin-top: 5px;">
          <img  src="https://0312-1256237687.cos.ap-beijing.myqcloud.com/20240201182903.png" alt="" width="120">
        </a>
      
      </div>

    </div>
  </div>
</template>
<script>
import { home } from "@/api/gxq";
// 低版本swiper
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
  },

  data() {
    return {
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
        },
        autoplay: true,
      },
      swiperOptions2: {
        slidesPerView: 4,
        navigation: {
          nextEl: ".swiper-button-next", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev", //后退按钮的css选择器或HTML元素。
          // hideOnClick: true, //点击slide时显示/隐藏按钮
          // disabledClass: "my-button-disabled", //前进后退按钮不可用时的类名。
          // hiddenClass: "my-button-hidden", //按钮隐藏时的Class
        },
      },
      swiperVisible: true,
      isLoading: true,
      isGuowu: true, //国务要闻
      isTongzhi: true, //通知公告
      isPersonal: true, //个人办事
      mouseSelsct: 0,
      shujuzz:[],
      tj: [],
      tjpics: [],
      yaowens: [],
      gqdongtais: [],
      gglunbos: [],
      gggss: [],
      spgs: [],
      youlinks: [],
      remengfws: [],
      gerenbss: [],
      farenbss: [],
      kuaijiefws: [],
      kjfw_look: [],
      kjfw_search: [],
      kjfw_ask: [],
      isPcs: true,
    };
  },
  mounted() {
    // console.log('测试打印123')
    this.getscreenWidth();
    this.homes();
    window.addEventListener("resize", this.getscreenWidth);
  },

  methods: {
    getscreenWidth() {
      var w = document.documentElement.clientWidth;
      if (w < 768) {
        this.swiperOptions2.slidesPerView = 1;
      } else if (w > 768 && w < 1200) {
        this.swiperOptions2.slidesPerView = 3;
      } else if (w > 1200) {
        this.swiperOptions2.slidesPerView = 4;
      }
      this.swiperVisible = false; //通过v-if切换，重新渲染swiper
      this.$nextTick(() => {
        this.swiperVisible = true;
      });
    },
    hideImg() {
      var lis = document
        .getElementById("iframesss")
        .contentWindow.document.getElementsByTagName("li");
      for (var j = 0; j < lis.length; j++) {
        lis[j].style.display = "flex";
        lis[j].children[0].style.width = "60%";
        lis[j].children[1].style.width = "90px";
      }
    },
    async homes() {
      var res = await home();
      this.farenbss = res.data.farenbs;
      this.gerenbss = res.data.gerenbs;
      this.gggss = res.data.gggs;
      this.spgs = res.data.spgs;
      this.gglunbos = res.data.gglunbo;
      this.gglunbos.forEach((item) => {
        this.$set(item, "state", 0);
        if (item.name == "生态环境") {
          this.$set(item, "url", "/ztzl?id=25&index=0");
          this.$set(item, "state", 1);
        }
        if (item.name == "食品安全") {
          this.$set(item, "url", "/ztzl?id=24&index=1");
          this.$set(item, "state", 1);
        }
        if (item.name == "公算") {
          this.$set(item, "url", "/MonList");
          this.$set(item, "state", 1);
        }
        if (item.name == "扶贫") {
          this.$set(item, "url", "/ztzl?id=27&index=2");
          this.$set(item, "state", 1);
        }
      });
      this.shujuzz = res.data.bsshuju;
      this.gqdongtais = res.data.gqdongtai;
      this.kuaijiefws = res.data.kuaijiefw;
      this.remengfws = res.data.remengfw;
      this.tj = res.data.stuijian[0];
      this.tjpics = res.data.tjpic;
      this.tjpics.forEach((item) => {
        this.$set(item, "state", 0);
        if (item.id == 27) {
          this.$set(item, "link", "/Dxarticles/27");
          this.$set(item, "state", 1);
        }
        if (item.id == 26) {
          this.$set(item, "link", "/Dxarticles/26");
          this.$set(item, "state", 1);
        }
      });
      this.yaowens = res.data.yaowen;
      this.youlinks = res.data.youlink;
      this.kjfw_ask = this.kjfw_ask.concat(
        res.data.kuaijiefw.data[0],
        res.data.kuaijiefw.data[1]
      );
      this.kjfw_search = this.kjfw_search.concat(
        res.data.kuaijiefw.data[2],
        res.data.kuaijiefw.data[3]
      );
      this.kjfw_look = this.kjfw_look.concat(
        res.data.kuaijiefw.data[4],
        res.data.kuaijiefw.data[5]
      );

      setTimeout(() => {
        this.isLoading = false;
      }, 100);
    },

    isGw(isGuowu) {
      if (isGuowu) {
        this.isGuowu = true;
      } else {
        this.isGuowu = false;
      }
    },
    isTg(isTongzhi) {
      if (isTongzhi) {
        this.isTongzhi = true;
      } else {
        this.isTongzhi = false;
      }
    },
    isPer(isPersonal) {
      if (isPersonal) {
        this.isPersonal = true;
      } else {
        this.isPersonal = false;
      }
    },
    mouseOver(mouseSelsct) {
      if (mouseSelsct == 0) {
        this.mouseSelsct = 0;
      }
      if (mouseSelsct == 1) {
        this.mouseSelsct = 1;
      }
      if (mouseSelsct == 2) {
        this.mouseSelsct = 2;
      }
    },
  },
};
</script>

<style scoped>
.floats{
  display: none;
  width:120px
}
.floats img{
  width: 120px;
}
/* 标题、描述、更多 单行布局 */
.cont_t_line {
  gap: 12px;
  position: relative;
}
.cont_t_line .cont_t_t_s {
  margin-bottom: 0;
  flex-shrink: 0;
  max-width: 45%;
}
.cont_t_line .cont_t_des_text {
  flex: 0 1 auto;
  min-width: 0;
  text-align: left;
  color: var(--primary-color);
}
.cont_t_line .cont_t_more {
  position: absolute;
  right: 0;
  flex-shrink: 0;
  color: var(--danger-color);
  font-size: 14px;
}

.truncate-text {
    /* 强制单行不换行 */
    white-space: nowrap;
    /* 超出部分隐藏 */
    overflow: hidden;
    /* 超出部分显示省略号 */
    text-overflow: ellipsis;
    /* 可选：设置最大宽度以触发溢出效果 */
    max-width: 100%;
    width: 100%;
    line-height: 100%;
  }
</style>
<style src="../../../vab/styles/index/index_big.css" scoped></style>
<style src="../../../vab/styles/index/index_mid.css" scoped></style>
<style src="../../../vab/styles/index/index_small.css" scoped></style>
<style>
/* Swiper 按钮优化 */
.swiper-button-next,
.swiper-button-prev {
  position: absolute;
  background-color: rgba(30, 136, 229, 0.8) !important;
  transform: scale(0.8, 0.8);
  color: #fff;
  background-size: 50%;
  border-radius: var(--radius-sm);
  transition: all var(--transition-fast);
}
.swiper-button-next:hover,
.swiper-button-prev:hover {
  background-color: var(--primary-color) !important;
  transform: scale(0.9, 0.9);
}
.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after {
  transform: scale(0.5, 0.5);
}
.swiper-button-next:after,
.swiper-container-rtl .swiper-button-prev:after {
  transform: scale(0.5, 0.5);
}

/* Banner 标题样式优化 */
.banner_tit {
  background: linear-gradient(90deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 100%);
  padding: 8px 16px;
  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
}

/* 列表项悬停效果 */
.rit_b li:hover a {
  color: var(--primary-color);
  padding-left: 4px;
}
.rit_b li:hover span {
  color: var(--primary-dark);
}

/* 标签切换优化 */
.tab-btn {
  padding: 6px 16px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
}
.tab-btn:hover {
  background: var(--primary-bg);
}
.tab-btn.active {
  background: var(--primary-color);
  color: #fff;
}

/* 图片悬停效果 */
.swiper-slide img {
  transition: transform var(--transition-normal);
}
.swiper-slide:hover img {
  transform: scale(1.02);
}

/* 链接悬停效果 */
.hover_a {
  position: relative;
}
.hover_a::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 1px;
  background: var(--primary-color);
  transition: width var(--transition-fast);
}
.hover_a:hover::after {
  width: 100%;
}
</style>

